import React, { useEffect } from 'react';
import $ from 'jquery'
import CourseCard from '../components/CourseCard';
// Components
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/courses.css'

export default function Courses() {
  
  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);
  
  return (
    <div className='courses_page page_body'>
      <PageTransition />
      <div className='container'>
        <div className='page_title select_n'>সকল কোর্সসমূহ</div>
        
        <div className='categories'>
          <div className='title select_n'>Filter by Categories:</div>
          <div className='category all active select_n' onClick={() => {$('.category.active').removeClass('active'); $('.category.all').addClass('active');}}><div className='bg'>All</div></div>
          <div className='category web_development select_n' onClick={() => {$('.category.active').removeClass('active'); $('.category.web_development').addClass('active');}}>
            <div className='bg'>Web Development</div>
          </div>
          <div className='category programming select_n' onClick={() => {$('.category.active').removeClass('active'); $('.category.programming').addClass('active');}}><div className='bg'>Programming</div></div>
        </div>
        <div className='courses_container'>
          <CourseCard
            thumbnail={require('../assets/images/course banners/banner-01.png')}
            title="প্রফেশনাল ফুল স্ট্যাক ওয়েব ডেভেলপমেন্ট কোর্স"
            mentors={[{mentorImage: require('../assets/images/mentor.jpg'), mentorName: 'মেন্টর নাম'}]}
            mentor="Forhad Hossain"
            mentorPic=""
            mainPrice=""
            discountPrice=""
            labels={["kdfjdkf"]}
          />
        </div>
      </div>
    </div>
  )
}
